import gql from 'graphql-tag';

export const CREATE_AFTERMARKET_PRODUCTS = gql`
  mutation CreateAftermarketProduct($input: CreateAftermarketProductInput!) {
    create: createAftermarketProduct(input: $input) {
      success
      errorMessage
      aftermarketProductId
    }
  }
`;
